<template>
  <ion-toolbar>
    <ion-title></ion-title>
  </ion-toolbar>

  <div class="main_wrapper ion-padding">
    <div class="container container-fill-height">
      <div class="auth-header">
        <div class="auth-heading">
          <h1>Internal Pool Invitation</h1>
        </div>
      </div>

      <div class="job_info_wrapper job_info_wrapper--custom">
        <div class="job_shifts_wrapper fullp">
          <div>
            <p>Hi,</p>
            <p>
              You’ve been invited to join the <b>{{ poolList }}</b> on {{ appName }}.
            </p>
          </div>

          <div>
            <p>Joining gives you:</p>
            <ul>
              <li><strong>Priority access to shifts</strong> – be the first to view and accept available work</li>
              <li><strong>Easy schedule management</strong> – see all your upcoming shifts in one place</li>
              <li><strong>Automated admin</strong> – if you’re a contractor, we’ll handle time-sheeting and invoicing for you</li>
            </ul>
          </div>

          <!-- Buttons -->
          <div class="button_submit mb0">
            <div class="btns-group">
              <el-button
                class="submit_page w-full"
                type="blue"
                @click="gotToAccept"
              >
                Accept
              </el-button>
              <el-button
                class="submit_page w-full secondary"
                type="red"
                @click="gotToReject"
              >
                Decline
              </el-button>
            </div>
          </div>

          <!-- Support Email -->
          <div class="mt-4 text-center">
            <p>
              Need help? Contact
              <a :href="`mailto:${supportEmail}`" class="support-link">{{ supportEmail }}</a>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted, inject } from "vue";
import { ElMessageBox } from "@/components/Vendor/Element";
import { addIcons } from "ionicons";
import { arrowBackOutline } from "ionicons/icons";
import { useStore } from "vuex";
import { useRouter, useRoute } from "vue-router";

addIcons({ "arrow-back-outline": arrowBackOutline });

export default {
  
  setup() {
    const $store = useStore();
    const $router = useRouter();
    const route = useRoute();
    const appName = process.env.VUE_APP_APP_NAME;
    const supportEmail = process.env.VUE_APP_SUPPORT_EMAIL;
    const setPageClassGlobal = inject("setPageClassGlobal");

    const poolList = ref("");

    // ❌ Handle decline
    const gotToReject = async () => {
      try {
        await $store.dispatch("INTERNAL_POOL_REJECT", {
          invitationId: route.params.invitationId,
        });

        await ElMessageBox.confirm("You have declined", "Internal Pool Declined!", {
          showCancelButton: false,
          confirmButtonText: "Sign up to Locumate",
          confirmButtonClass: "el-button--grey",
          showClose: true,
          type: "warning",
          customClass: "modal_success star declined-invitation",
          callback: () => $router.push({ name: "auth" }),
        });
      } catch (error) {
        console.error(error);
      }
    };

    // ✅ Handle accept
    const gotToAccept = async () => {
      try {

        await $store.dispatch("INTERNAL_POOL_ACCEPT", {
          invitationId: route.params.invitationId,
        });

        await ElMessageBox.confirm(
          `You’ve successfully joined the ${poolList.value}. You’ll now receive priority notifications for available shifts.`,
          "You’re In!",
          {
            showCancelButton: false,
            confirmButtonText: "Ok",
            confirmButtonClass: "el-button--grey",
            type: "success",
            customClass: "modal_success star",
            callback: () => $router.push({ name: "home" }),
          }
        );
      } catch (error) {
        console.error(error);
      }
    };

    // 🚀 Lifecycle
    onMounted(async () => {
      if (setPageClassGlobal) setPageClassGlobal("global_job_book_page");

      const internalPoolInfo = await $store.dispatch("GET_INTERNAL_POOL_INFO", {
        invitationId: route.params.invitationId,
      });

      poolList.value =
        internalPoolInfo.internalPoolList?.internalpoollistable?.name ||
        internalPoolInfo.internalPoolList?.displayName ||
        "";
    });

    return {
      gotToAccept,
      gotToReject,
      poolList,
      appName,
      supportEmail,
      close,
    };
  },
};
</script>
